//@flow
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {BForm, Form} from './Form'
import {Col, Row} from "react-bootstrap";
import {useMsgs} from "./Language";
import {store} from "../application";
import type {ValidationRules} from "./Validation";

export type ReportParamField = 'data_start' | 'data_koniec' | 'etap';

export type ReportParamsProps = {
    fields: Array<ReportParamField>;
    // initialValues: ReportParamsField;
    onSubmit: (params: ReportParamsField) => void;
    children?: React$Node;
}

export type ReportParamsField = {
    data_start: string;
    data_koniec: string;
    etap: string;
}

const initialValues: ReportParamsField = {
    data_start: '',
    data_koniec: '',
    etap: ''
}

const StagesSelect = () => {
    const [dicts, setDicts] = useState<Array<string>>(null);
    useEffect(() => {
        store.userApi.getVindicationDictionaries().then((dicts) => setDicts(dicts.statuses))
    }, [ setDicts ]);
    if(dicts===null) return <BForm.Control custom as="select" value=""/>

    return <Form.Select>
        <option value=""></option>
        {dicts.map(v => <option value={v}>{v}</option>)}
    </Form.Select>
}


/**
 * Komponent, który wyświetla parametry do raportu.
 * @author Ryszard Trojnacki
 */
export const ReportParams = ({ fields, children, onSubmit }: ReportParamsProps) => {
    const msgs = useMsgs();
    const [ processing, setProcessing ] = useState(false);
    const handleSubmit = useCallback((params) => {
        if (processing) return;
        setProcessing(true);
        try {
            onSubmit(params);
        } finally {
            setProcessing(false);
        }
    }, [ onSubmit, processing, setProcessing ]);
    const validationRules=useMemo(() => {
        const rules: ValidationRules = {};
        if(fields.includes('data_start')) {
            rules['data_start']={ required: true };
        }
        if(fields.includes('data_koniec')) {
            rules['data_koniec']={ required: true };
        }
        return rules;
    }, [ fields ]);


    return <Form initialValues={initialValues} onSubmit={handleSubmit} validate={validationRules}>{(formik) => <>
        <Row xs={1} sm={1} md={2} lg={2} xl={3}>
            {fields.includes('data_start') && <Form.ColGroup className="my-3" name="data_start">
                <Form.Label>{msgs.gui.reportsDateFrom}</Form.Label>
                <Form.Date/>
            </Form.ColGroup>}
            {fields.includes('data_koniec') && <Form.ColGroup className="my-3" name="data_koniec">
                <Form.Label>{msgs.gui.reportsDateTo}</Form.Label>
                <Form.Date/>
            </Form.ColGroup>}
            {fields.includes('etap') && <Form.ColGroup className="my-3" name="etap">
                <Form.Label>{msgs.gui.reportsStage}</Form.Label>
                <StagesSelect/>
            </Form.ColGroup>}
        </Row>
        <Row className="mt-2">
            <Col>
                <Form.Submit disabled={processing}>{msgs.gui.actionDownload}</Form.Submit>
            </Col>
        </Row>
        {children}
    </>
    }</Form>
}
